import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  goal: Yup.string().required("Goal ist erforderlich"),
  geschlecht: Yup.string().required("Geschlecht ist erforderlich"),
  vorname: Yup.string().required("Vorname ist erforderlich"),
  nachname: Yup.string().required("Nachnamn ist erforderlich"),
  email: Yup.string()
    .email("Ungültige E-Mail-Adresse")
    .required("E-Mail ist erforderlich"),
  handynummer: Yup.string().required("Handynummer ist erforderlich"),
  help: Yup.string().required("Help ist erforderlich"),
});
